import React from 'react';
import './Footer.css';
// Import the image if it's stored in your source folder (e.g., src/assets)
// If it's in the public folder, the path '/embryo-removebg.png' is fine.
// If you are using Webpack/Vite:
// import DigitalLabLogo from '/embryo-removebg.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-text">
          <span className="powered-by">Powered By</span>
          {/* REPLACED TEXT SPAN WITH IMAGE */}
          <img 
            src="/embryo-removebg.png" 
            alt="SLT Digital Lab Logo" 
            className="digital-lab-logo" 
          />
        </div>
        <div className="footer-divider"></div>
        <div className="footer-year">
          © {currentYear}
        </div>
        {/* ... (footer-links commented out) */}
      </div>
    </footer>
  );
};

export default Footer;